<ng-container *ngIf="label">
  <om-label [text]="label" [icon]="icon" [isRequired]="this.required"></om-label>
</ng-container>
<div class="flexrow-nowrap-start gap-2">
  <div class="w-3/5">
    <om-time-input _class="w-1/2" [placeholder]="fromPlaceholder" [control]="control.get('from')"></om-time-input>
    <om-time-input _class="w-1/2" [placeholder]="toPlaceholder" [control]="control.get('to')"></om-time-input>
  </div>

  <ng-container *ngIf="deletable">
      <span
        class="cursor-pointer mt-2"
        nz-icon
        nzType="close-circle"
        nzTheme="twotone"
        nzTwotoneColor="#d81111"
        nz-tooltip
        nzTooltipTitle="{{ 'SETTINGS.CALENDARS_SETTINGS.DELETE' | translate }}"
        style="font-size: 18px"
        (click)="_emitClose($event)"
      ></span>
  </ng-container>
</div>
